export const ConvertMilliInHourMin = (value) => {
    let minutes = Math.floor((value / (1000 * 60)) % 60);
    let hours = Math.floor((value / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    return hours + ":" + minutes;
}